<template>
  <section>
    <ModificarCronograma />
    <AnularCronograma />
    <EnviarCronograma />
    <Ver />
    <crear-actualizar-vacaciones />
    <h4 class="primary--text">
      <span class="material-symbols-outlined span-icon">
        calendar_month
      </span>
      Programación de vacaciones {{ gestion_parametro }}
    </h4>
    <v-card-text class=" px-0 py-2 grey lighten-2 text--info">
      <v-layout wrap>
        <v-flex class="px-3">
          <v-btn icon color="primary" to="/vacaciones">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <strong> Listado de gestiones</strong>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card>
      <v-card-text class="px-3 py-1">
        <DatosPersonalesProgramacion
          v-if="!!estado_vacacion.id"
          :id_estado_vacacion="estado_vacacion.id"
          v-model="total_dias_programar"
        />
      </v-card-text>
      <v-card-text class="text-xs-center py-1">
        <v-card color="indigo" class="px-3 white--text ">
          <span class="caption">NÚMERO DE DÍAS RESTANTES A PROGRAMAR</span
          ><br />
          <span class="display-1">{{
            total_dias_programar - total_dias_programados
          }}</span>
        </v-card>
      </v-card-text>
      <v-card-text class="py-0">
        <v-tooltip bottom>
          <v-btn
            color="primary"
            @click.native.stop="crearActualizarVacaciones({})"
            slot="activator"
            :disabled="
              !(
                estado_vacacion.id_estado_programacion == 22 ||
                estado_vacacion.id_estado_programacion == 47
              ) || bandera_rango_fecha == false
            "
            ><v-icon dark>add</v-icon> Nuevo</v-btn
          >
          <span>Nuevo</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn
            color="primary"
            @click.native.stop="enviarCronograma()"
            slot="activator"
            :disabled="
              !(
                estado_vacacion.id_estado_programacion == 22 ||
                estado_vacacion.id_estado_programacion == 47
              ) || bandera_rango_fecha == false
            "
            ><v-icon dark>send</v-icon> Enviar</v-btn
          >
          <span>Enviar</span>
        </v-tooltip>
        <!-- Boton filtro -->
        <v-tooltip bottom>
          <v-btn
            @click.native="
              () => {
                filterShow = filterShow ? false : true;
              }
            "
            class="btn-refresh"
            slot="activator"
            ><v-icon>filter_list</v-icon>
          </v-btn>
          <span>Búsqueda/filtros</span>
        </v-tooltip>
        <!-- Boton acutualizar -->
        <v-tooltip bottom>
          <v-btn
            @click.native="cargarProgramaciones()"
            class="btn-refresh"
            slot="activator"
            ><v-icon>refresh</v-icon>
          </v-btn>
          <span>{{ $t("common.updateList") }}</span>
        </v-tooltip>
        <v-flex xs12>
          <transition name="slide-fade">
            <div class="filter-container-rrhh" v-show="filterShow">
              <v-icon small color="primary">search</v-icon>

              <div class="filter-item">
                <v-text-field
                  label="Nro papeleta"
                  v-model="form.secuencia"
                  @input="filterSecuencia"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Fecha salida"
                  v-model="form.ap_paterno"
                  @input="filterFechaDesde"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Fecha fin"
                  v-model="form.fecha_hasta"
                  @input="filterFechaHasta"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Dias"
                  v-model="form.total_dias"
                  @input="filterTotalDias"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Estado"
                  v-model="form.estado"
                  @input="filterEstado"
                ></v-text-field>
              </div>
              <!-- botones cerrar -->
              <div class="btn-filter">
                <v-tooltip bottom>
                  <v-btn icon small slot="activator" @click.native="recargar()">
                    <v-icon small>refresh</v-icon>
                  </v-btn>
                  <span>Recargar filtros</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    @click.native="
                      () => {
                        filterShow = false;
                        recargar();
                      }
                    "
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                  <span>Cerrar filtros</span>
                </v-tooltip>
              </div>
            </div>
          </transition>
        </v-flex>
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :headers="headers"
          :items="l_programaciones"
          hide-actions
          :search="filters"
          :custom-filter="customFilter"
        >
          <template v-slot:items="items">
            <td class="text-xs-center">{{ items.item.secuencia }}</td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_desde).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_hasta).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">{{ items.item.total_dias }}</td>
            <td class="text-xs-center">{{ items.item.estado }}</td>
            <td>
              <v-btn
                color="green"
                dark
                v-if="
                  (items.item.id_estado == 22 || items.item.id_estado == 47) &&
                    bandera_rango_fecha
                "
                @click.native="modificarProgramacion(items.item)"
                icon
                title="Modificar"
              >
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn
                color="red"
                dark
                v-if="
                  (items.item.id_estado == 22 || items.item.id_estado == 47) &&
                    bandera_rango_fecha
                "
                @click.prevent="anularCronograma(items.item)"
                icon
                title="Anular"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:footer>
            <td colspan="3" class="footer-table">
              <strong>{{ `Total dias programados` }}</strong>
            </td>
            <td class="text-xs-center title">
              <strong>{{ total_dias_programados }}</strong>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrearActualizarVacaciones from "./dialogs/CrearActualizarVacaciones"; // Componente de creación y actualización
import ModificarCronograma from "./dialogs/ModificarCronograma";
import AnularCronograma from "./dialogs/AnularCronograma.vue";
import EnviarCronograma from "./dialogs/EnviarCronograma.vue";
import Ver from "./dialogs/Ver";
import DatosPersonalesProgramacion from "./components/DatosPersonalesProgramacion.vue";
import filtrosProgramacion from "./mixins/filtrosProgramacion";
export default {
  mixins: [filtrosProgramacion],
  data() {
    return {
      user: this.$storage.get("user"),
      id_persona: this.$storage.get("user").id_persona,
      total_dias_programar: null,
      gestion_parametro: parseInt(this.$route.params.gestion),
      bandera_rango_fecha: true,
      estado_vacacion: {},
      // Variables de la tabla
      l_programaciones: [],
      headers: [
        { text: "Nro de papeleta", value: "secuencia", align: "center" },
        { text: "Fecha inicio", value: "fecha_desde", align: "center" },
        { text: "Fecha fin", value: "fecha_hasta", align: "center" },
        { text: "Días", value: "total_dias", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Variables filtros
      filterShow: true,
      filters: {
        secuencia: "",
        fecha_desde: "",
        fecha_hasta: "",
        total_dias: "",
        estado: ""
      },
      form: {}
    };
  },
  computed: {
    total_dias_programados() {
      return this.l_programaciones.reduce((accumulator, current) => {
        // Excluimos registros anulados
        return (
          accumulator +
          ([9, 83].includes(current.id_estado) ? 0 : current.total_dias)
        );
      }, 0);
    }
  },
  async mounted() {
    this.$bus.$on("closeDialogVerReporteCronograma", async () => {});
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    await this.cargarEstadoVacacion();
    await this.cargarProgramaciones();
    await this.verificarRangoFinProgramacion();
    this.$bus.$on("closeDialogAnularCronograma", async () => {
      await this.cargarProgramaciones();
      await this.cargarEstadoVacacion();
    });
    this.$bus.$on("closeDialogEnviarCronograma", async () => {
      await this.cargarProgramaciones();
      await this.cargarEstadoVacacion();
    });
    this.$bus.$on("closeDialogModificarCronograma", async () => {
      await this.cargarProgramaciones();
      await this.cargarEstadoVacacion();
    });
    this.$bus.$on("closeDialogCrearActualizarVacaciones", async () => {
      await this.cargarProgramaciones();
      await this.cargarEstadoVacacion();
    });
  },

  methods: {
    // Metodo para cargar el listado de programaciones
    async cargarProgramaciones() {
      let l_tmp = await this.$query.select(
        "v_vaca_programada",
        { id_persona: this.id_persona, gestion: this.$route.params.gestion },
        [
          "id",
          "id_persona",
          "id_estado",
          "fecha_desde",
          "fecha_hasta",
          "fecha_solicitud",
          "total_dias",
          "gestion",
          "estado",
          "saldo_a_reprogramar",
          "secuencia"
        ]
      );
      // Arreglamos formatos de fechas
      l_tmp.forEach(element => {
        element.fecha_desde = this.$moment(
          element.fecha_desde,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
        element.fecha_hasta = this.$moment(
          element.fecha_hasta,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
      });
      this.l_programaciones = l_tmp;
    },
    //verificar si aun esta en el rango de fechas de programacion:
    async verificarRangoFinProgramacion() {
      // Obtenemos datos de la programacion
      let datos_programacion = await this.$query.select(
        "programacion",
        { gestion: parseInt(this.$route.params.gestion) },
        ["fecha_fin", "fecha_ampliacion", "fecha_inicio"]
      );
      datos_programacion = datos_programacion[0];
      // Verificamos que aun hay plazo
      if (
        (this.$moment(datos_programacion.fecha_inicio) <=
          this.$moment().startOf("day") &&
          this.$moment().startOf("day") <=
            this.$moment(datos_programacion.fecha_fin)) ||
        (this.$moment(datos_programacion.fecha_inicio) <=
          this.$moment().startOf("day") &&
          this.$moment().startOf("day") <=
            this.$moment(datos_programacion.fecha_ampliacion))
      ) {
        this.bandera_rango_fecha = true;
      } else {
        this.bandera_rango_fecha = false;
      }
    },

    modificarProgramacion(item) {
      this.$bus.$emit("openDialogModificarCronograma", item);
    },

    ver(item) {
      this.$bus.$emit("openDialogVer", item);
    },
    crearActualizarVacaciones(item) {
      this.$bus.$emit("openDialogCrearActualizarVacaciones", item);
    },

    anularCronograma(item) {
      this.$bus.$emit("openDialogAnularCronograma", item);
    },
    enviarCronograma() {
      let item = {
        id_estado_vacacion: this.estado_vacacion.id
      };
      if (this.total_dias_programar - this.total_dias_programados == 0) {
        this.$bus.$emit("openDialogEnviarCronograma", item);
      } else {
        this.$confirm(
          "Usted no puede continuar debido a que no realizó el total de sus programaciones",
          () => {}
        );
      }
    },

    async cargarEstadoVacacion() {
      try {
        this.estado_vacacion = await this.$query.select(
          "v_estado_vacacion",
          {
            id_persona: this.id_persona,
            gestion_hasta: this.gestion_parametro + ""
          },
          ["id", "id_estado", "id_estado_programacion"]
        );
        this.estado_vacacion = this.estado_vacacion[0];
      } catch (error) {
        console.log(error);
      }
    }
  },
  components: {
    CrearActualizarVacaciones,
    ModificarCronograma,
    AnularCronograma,
    EnviarCronograma,
    Ver,
    DatosPersonalesProgramacion
  }
};
</script>
<style scoped lang="scss">
.footer-table {
  background-color: rgba(0, 92, 167, 0.699);
  color: rgba(255, 255, 255, 1);
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/Programar.vue